export default {
  path: '/providers',
  name: 'providers.index',
  redirect: { name: 'providers.templates-page' },
  component: () =>
    import(/* webpackChunkName: "providers" */ '@/views/providers/index.vue'),
  children: [
    {
      path: '/providers',
      name: 'providers.templates-page',
      component: () =>
        import(
          /* webpackChunkName: "providers-list-page" */ '@/views/providers/ProvidersPage.vue'
        ),
    },
    {
      path: '/provider/:id',
      name: 'provider.list-page',
      component: () =>
        import(
          /* webpackChunkName: "providers-form-page" */ '@/views/providers/ProviderListPage.vue'
        ),
    },
  ],
}
